import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthResponse, CurrentUser, LoginRequest } from '../models/auth.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private apiUrl = `${environment.rpsApiUrl}/api/Auth`;

  currentUser = signal<CurrentUser | null>(this.loadUser());

  login(dto: LoginRequest) {
    return this.http.post<AuthResponse>(`${this.apiUrl}/login`, dto);
  }

  setSession(res: AuthResponse) {
    localStorage.setItem('rps_token', res.token);
    const user: CurrentUser = {
      userId: res.userId, userName: res.userName,
      email: res.email, roleName: res.roleName, roleId: res.roleId
    };
    localStorage.setItem('rps_user', JSON.stringify(user));
    this.currentUser.set(user);
  }

  logout() {
    localStorage.removeItem('rps_token');
    localStorage.removeItem('rps_user');
    this.currentUser.set(null);
    this.router.navigate(['/login']);
  }

  getToken() { return localStorage.getItem('rps_token'); }
  isLoggedIn() { return !!this.getToken(); }

  private loadUser(): CurrentUser | null {
    try {
      const d = localStorage.getItem('rps_user');
      return d ? JSON.parse(d) : null;
    } catch { return null; }
  }
}
